export enum VoiceProvider {
    OPENAI = "OPENAI",
    AURA = "AURA",
    PLAYHT = "PLAYHT",
    CARTESIA = "CARTESIA",
    ELEVENLABS = "ELEVENLABS"
}